import React from 'react'
import styles from './Details.module.css'

interface DetailsProps {
    items: { label: string, value: string}[]
    accentValues: boolean
}

const Details = ({ items, accentValues }: DetailsProps) => {
    return (
        <div className={styles.details}>
            {items.map(({ label, value }, index) => (
                <div className={styles.detailRow} key={index}>
                    <span className={styles.detailLabel}>{label}</span>
                    <span className={`${styles.detailValue} ${accentValues ? styles.detailValueAccent : ''}`}>{value}</span>
                </div>
            ))}
        </div>
    )
}

export default Details
